import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'childcare_fac_not_provided_adequate_supplies_infrastructure'

export const dataPointDefinition = {
  retracedId: 'childcare_fac_not_provided_adequate_supplies_infrastructure',
  name: 'Childcare facilities are not provided with adequate supplies and infrastructure (i.e., food, recreational items, washroo',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-chi-6x',
      number: 'HS-CHI-2-3',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-chi-3',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],fp-bs-8,Yes',
      machineShowHide: '[2],fp-bs-8,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-chi-6x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30470,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
